import cx from 'classnames';
import { BZ_CONTACT_OR_sendmsg } from 'mk/autogenerated/translations/ContactSellerActionsStep2.a7a1270a2ec44c4ce5bcb95c50ad272c'
import { Interpolate } from 'mk2/components/Interpolate';
import React from 'react';
import styles from './ContactSellerActionsStep2.mscss';

interface OwnProps {
    orderBtn: React.ReactNode;
    showMsgsBtn: React.ReactNode;
    inline?: boolean;
}

export const ContactSellerActionsStep2: React.FunctionComponent<OwnProps> = ({
    orderBtn, showMsgsBtn, inline = false,
}) => {
    return orderBtn ? (
        <div className={cx(
            styles.ContactSellerActionsStep2,
            inline
                ? styles['ContactSellerActionsStep2--row']
                : styles['ContactSellerActionsStep2--col'],
            !inline && !showMsgsBtn && styles['ContactSellerActionsStep2--needsBottomPadding'],
        )}>
            {/*
                <Kúp> alebo <zobraz komunikáciu s predajcom>
                <Kúp>
            */}
            {orderBtn}

            {showMsgsBtn && (
                <Interpolate
                    className={cx(
                        styles.ContactSellerActionsStep2__secondary,
                        inline
                            ? styles['ContactSellerActionsStep2__secondary--row']
                            : styles['ContactSellerActionsStep2__secondary--col'],
                    )}
                    parent={inline ? 'span' : 'div'}
                    i18nKey={BZ_CONTACT_OR_sendmsg}
                    sendmsg={showMsgsBtn}
                />
            )}
        </div>
    ) : showMsgsBtn ? (
        <div className={cx(
            styles.ContactSellerActionsStep2,
            inline
                ? styles['ContactSellerActionsStep2--row']
                : styles['ContactSellerActionsStep2--col'],
            !inline && styles['ContactSellerActionsStep2--needsBottomPadding'],
        )}>
            {/*
                <zobraz komunikaciu s predajcom>
            */}
            {showMsgsBtn}
        </div>
    ) : null;
};
